"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSrollbarMouseHandler = initSrollbarMouseHandler;
exports.disableSwipeIfScrollable = disableSwipeIfScrollable;
const helpers_1 = require("../../../../scripts/helpers");
const selectors = ['.scrollbar', '.scrollbar-md-down', '.scrollbar-disable'];
const DRAGGING_STATE_CLASSNAME = 'scrollbar--dragging';
const DRAGGING_POSSIBLE_CLASSNAME = 'scrollbar-is-scrollable-desktop';
// @todo есть баг в табах неактивные табы не инициализирются карточки на драг эффект
function initSrollbarMouseHandler($el = null) {
    if ($el) {
        setDraggableScrollableElement($el);
    }
    else {
        const scrollableElements = document.querySelectorAll(selectors.join(', '));
        scrollableElements.forEach(setDraggableScrollableElement);
    }
}
function setDraggableScrollableElement($scrollableElement) {
    /** Выходим, если устройство поддерживает тач */
    if ('ontouchstart' in window)
        return;
    const scrollbarData = {
        isDragging: false,
        startX: 0,
        scrollLeft: 0,
        speed: +$scrollableElement.getAttribute('data-drag-scroll-speed') || 1,
        isScrollable: false,
    };
    const mousedownHandler = (e) => {
        scrollbarData.isDragging = true;
        scrollbarData.startX = e.pageX - $scrollableElement.offsetLeft;
        scrollbarData.scrollLeft = $scrollableElement.scrollLeft;
    };
    const mousemoveHandler = (e) => {
        const x = e.pageX - $scrollableElement.offsetLeft;
        const xWithSpeed = (x - scrollbarData.startX) * scrollbarData.speed;
        $scrollableElement.scrollLeft = scrollbarData.scrollLeft - xWithSpeed;
    };
    const mouseupHandler = () => {
        scrollbarData.isDragging = false;
    };
    const updateScrollable = () => {
        scrollbarData.isScrollable = (0, helpers_1.canScrollX)($scrollableElement);
        if (scrollbarData.isScrollable) {
            $scrollableElement.classList.add(DRAGGING_POSSIBLE_CLASSNAME);
        }
        else {
            $scrollableElement.classList.remove(DRAGGING_POSSIBLE_CLASSNAME);
        }
    };
    (0, helpers_1.listenPropChange)(scrollbarData, 'isDragging', value => {
        if (value === true) {
            $scrollableElement.classList.add(DRAGGING_STATE_CLASSNAME);
            document.addEventListener('mousemove', mousemoveHandler);
            document.addEventListener('mouseup', mouseupHandler);
        }
        else {
            $scrollableElement.classList.remove(DRAGGING_STATE_CLASSNAME);
            document.removeEventListener('mousemove', mousemoveHandler);
            document.removeEventListener('mouseup', mouseupHandler);
        }
    });
    (0, helpers_1.listenPropChange)(scrollbarData, 'isScrollable', value => {
        if (value === true) {
            $scrollableElement.addEventListener('mousedown', mousedownHandler);
        }
        else {
            $scrollableElement.removeEventListener('mousedown', mousedownHandler);
        }
    });
    const observer = new MutationObserver((0, helpers_1.debounce)(updateScrollable, 250));
    observer.observe($scrollableElement, { childList: true, subtree: true, attributes: false });
    window.addEventListener('resize', (0, helpers_1.debounce)(updateScrollable, 250));
    updateScrollable();
}
/**
 * Отключает свайп на свайпере если свайпится scrollbar
 *
 * @param swiper
 */
function disableSwipeIfScrollable(swiper) {
    selectors.forEach(scrollbarSelector => {
        const scrollableElements = document.querySelectorAll(scrollbarSelector); // Ваш скролящийся элемент
        scrollableElements.forEach($scrollableElement => {
            if ((0, helpers_1.canScrollX)($scrollableElement)) {
                disableSwiperTouchMove($scrollableElement, swiper);
            }
            else {
                enableSwiperTouchMove($scrollableElement, swiper);
            }
            let setUnsetSwiperTouchMove = (0, helpers_1.debounce)(function (e) {
                if ((0, helpers_1.canScrollX)($scrollableElement)) {
                    disableSwiperTouchMove($scrollableElement, swiper);
                }
                else {
                    enableSwiperTouchMove($scrollableElement, swiper);
                }
            }, 250);
            window.addEventListener('resize', setUnsetSwiperTouchMove);
        });
    });
}
function disableSwiperTouchMove($el, swiper) {
    // mob
    $el.addEventListener('touchstart', e => {
        swiper.allowTouchMove = false;
    });
    $el.addEventListener('touchend', e => {
        swiper.allowTouchMove = true;
    });
    // pc
    $el.addEventListener('mousemove', e => {
        swiper.allowTouchMove = false;
    });
    $el.addEventListener('mouseup', e => {
        swiper.allowTouchMove = true;
    });
    $el.addEventListener('mouseleave', e => {
        swiper.allowTouchMove = true;
    });
}
function enableSwiperTouchMove($el, swiper) {
    // mob
    $el.addEventListener('touchstart', e => {
        swiper.allowTouchMove = true;
    });
    // pc
    $el.addEventListener('mousemove', e => {
        swiper.allowTouchMove = true;
    });
}
